import {
    createRouter,
    createWebHistory,
    createWebHashHistory,
    RouteRecordRaw,
    useRouter,
} from "vue-router";
import HomeView from "../views/HomeView.vue";
import IndexView from "../views/IndexViews/indexView.vue";
import Index2 from "./index2";
import PharmacyIndex from "./pharmacyindex";
import gupiao from "./gupiao";
import YjyDsj from "../views/yjyDsj.vue";
const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        name: "index",
        component: IndexView,
    },
    {
        path: "/search",
        name: "search",
        component: () =>
            import(
                /* webpackChunkName: "realtime" */ "../views/IndexViews/SearchView.vue"
            ),
    },
    {
        path: "/i",
        name: "i",
        component: () =>
            import(
                /* webpackChunkName: "realtime" */ "../views/IndexViews/index2.vue"
            ),
    },
    {
        path: "/home",
        name: "home",
        component: HomeView,
        redirect: "/realtime",
        children: [
            {
                path: "/realtime", //实时大屏
                name: "realtime",
                component: () =>
                    import(
                        /* webpackChunkName: "realtime" */ "../views/RealTime.vue"
                    ),
                meta: {
                    title: "实时大屏页面",
                },
            },
            {
                path: "/platform", //平面统计
                name: "platform",
                component: () =>
                    import(
                        /* webpackChunkName: "platform" */ "../views/PlatForms/PlatForm.vue"
                    ),
                meta: {
                    title: "平面统计页面",
                },
            },
            {
                path: "/platform2",
                name: "platform2",
                component: () =>
                    import(
                        /* webpackChunkName: "platform2" */ "../views/PlatForms/PlatForm2.vue"
                    ),
                meta: {
                    title: "平面统计页面",
                },
            },
            {
                path: "/shopping", //商城统计
                name: "shopping",
                component: () =>
                    import(
                        /* webpackChunkName: "shopping" */ "../views/ShoppingMall/ShopPing.vue"
                    ),
                meta: {
                    title: "商城统计页面",
                },
            },
            {
                path: "/shopping2", //商城统计
                name: "shopping2",
                component: () =>
                    import(
                        /* webpackChunkName: "shopping2" */ "../views/ShoppingMall/ShopPing2.vue"
                    ),
                meta: {
                    title: "商城统计页面",
                },
            },
            {
                path: "/shopping3", //商城统计
                name: "shopping3",
                component: () =>
                    import(
                        /* webpackChunkName: "shopping3" */ "../views/ShoppingMall/ShopPing3.vue"
                    ),
                meta: {
                    title: "商城统计页面",
                },
            },
            {
                path: "/shopping4", //商城统计
                name: "shopping4",
                component: () =>
                    import(
                        /* webpackChunkName: "shopping4" */ "../views/ShoppingMall/ShopPing4.vue"
                    ),
                meta: {
                    title: "商城统计页面",
                },
            },
            {
                path: "/shopping5", //商城统计
                name: "shopping5",
                component: () =>
                    import(
                        /* webpackChunkName: "shopping5" */ "../views/ShoppingMall/ShopPing5.vue"
                    ),
                meta: {
                    title: "商城统计页面",
                },
            },
            {
                path: "/product", //产品流向
                name: "product",
                component: () =>
                    import(
                        /* webpackChunkName: "product" */ "../views/ProductFlow/Products.vue"
                    ),
                meta: {
                    title: "产品流向页面",
                },
            },
            {
                path: "/product2", //产品流向
                name: "product2",
                component: () =>
                    import(
                        /* webpackChunkName: "product2" */ "../views/ProductFlow/Products2.vue"
                    ),
                meta: {
                    title: "产品流向页面",
                },
            },
            {
                path: "/product3", //产品流向
                name: "product3",
                component: () =>
                    import(
                        /* webpackChunkName: "product3" */ "../views/ProductFlow/Products3.vue"
                    ),
                meta: {
                    title: "产品流向页面",
                },
            },
            {
                path: "/purchaser", //采购商
                name: "purchaser",
                component: () =>
                    import(
                        /* webpackChunkName: "purchaser" */ "../views/PurChasers/PurChaser.vue"
                    ),
                meta: {
                    title: "采购商页面",
                },
            },
            {
                path: "/purchaser2", //采购商
                name: "purchaser2",
                component: () =>
                    import(
                        /* webpackChunkName: "purchaser2" */ "../views/PurChasers/PurChaser2.vue"
                    ),
                meta: {
                    title: "采购商页面",
                },
            },
            {
                path: "/supplier", //供应商
                name: "supplier",
                component: () =>
                    import(
                        /* webpackChunkName: "purchaser" */ "../views/SupPliers/SupPlier.vue"
                    ),
                meta: {
                    title: "供应商页面",
                },
            },
            {
                path: "/supplier2", //供应商
                name: "supplier2",
                component: () =>
                    import(
                        /* webpackChunkName: "purchaser2" */ "../views/SupPliers/SupPlier2.vue"
                    ),
                meta: {
                    title: "供应商页面",
                },
            },
            {
                path: "/brand", //品牌分析
                name: "brand",
                component: () =>
                    import(
                        /* webpackChunkName: "brand" */ "../views/BrandAnalysis/BrandView.vue"
                    ),
                meta: {
                    title: "品牌分析页面",
                },
            },
            {
                path: "/brand2", //品牌分析
                name: "brand2",
                component: () =>
                    import(
                        /* webpackChunkName: "brand2" */ "../views/BrandAnalysis/BrandView2.vue"
                    ),
                meta: {
                    title: "品牌分析页面",
                },
            },
            {
                path: "/regional", //区域分析
                name: "regional",
                component: () =>
                    import(
                        /* webpackChunkName: "regional" */ "../views/RegionalAnalysis/RegionalView.vue"
                    ),
                meta: {
                    title: "区域分析页面",
                },
            },
        ],
    },
    {
        path: "/yjyDsj",
        name: "yjyDsj",
        // component: YjyDsj,
        redirect: "/numberStore",
        children: [
            {
                path: "/numberStore", //壹加壹掌柜数字门店
                name: "numberStore",
                component: () =>
                    import(
                        /* webpackChunkName: "numberStore" */ "../views/yjyDsj/numberStore.vue"
                    ),
                meta: {
                    title: "壹加壹掌柜数字门店",
                },
            },
            {
                path: "/fzYp", //方舟控股·方舟优品产销中台
                name: "fzYp",
                component: () =>
                    import(
                        /* webpackChunkName: "ecologicalGrowth" */ "../views/yjyDsj/fzYp.vue"
                    ),
                meta: {
                    title: "方舟控股·方舟优品产销中台",
                },
            },
            {
                path: "/ecologicalGrowth", //方舟控股-生态增长飞轮
                name: "ecologicalGrowth",
                component: () =>
                    import(
                        /* webpackChunkName: "ecologicalGrowth" */ "../views/yjyDsj/ecologicalGrowth.vue"
                    ),
                meta: {
                    title: "方舟控股-生态增长飞轮",
                },
            },
        ],
    },
    ...Index2,
    ...PharmacyIndex,
    ...gupiao,
    {
        path: "/digitalEnterprise",
        name: "digitalEnterprise",
        component: () =>
            import(
                /* webpackChunkName: "digitalEnterprise" */ "../views/DigitalEnterprise/index.vue"
            ),
        meta: {
            title: "方舟控股·方舟数企赋能平台",
        },
    },
    {
        path: "/enterpriseList", //企业列表
        name: "enterpriseList",
        component: () =>
            import(
                /* webpackChunkName: "enterpriseList" */ "../views/DigitalEnterprise/enterpriseList.vue"
            ),
        meta: {
            title: "企业列表",
        },
    },
    {
        path: "/enterpriseDetails", //企业详情
        name: "enterpriseDetails",
        component: () =>
            import(
                /* webpackChunkName: "enterpriseDetails" */ "../views/DigitalEnterprise/enterpriseDetails.vue"
            ),
        meta: {
            title: "企业详情",
        },
    },
    {
        path: "/:catchAll(.*)", //通配符: 匹配所有不存在的路径
        name: "404",
        component: () => import("../views/IndexViews/NotFound.vue"),
        meta: {
            title: "404页面",
        },
    },
];

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),

    // history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach((to, from, next) => {
    // to: 到哪去   from: 从哪来   next: 是否放行
    // console.log('to:', to)
    // console.log('from:', from)

    // 读取 to中 meta里的title 设置为标签栏的题目
    const title = (to.meta.title ? to.meta.title : "大数据系统") + "";
    document.title = title;

    next(); //放行, 允许路由跳转
});

export default router;
